/**
 * Route for `real-time-anomaly-ml-cr-drop-fraud-spike-deposit-drop-with-s`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSPage } from "../features/real-time-anomaly-ml-cr-drop-fraud-spike-deposit-drop-with-s/RealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSPage";

export const realTimeAnomalyMlCrDropFraudSpikeDepositDropWithSRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/real-time-anomaly-ml-cr-drop-fraud-spike-deposit-drop-with-s",
	component: RealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSPage,
});

export default realTimeAnomalyMlCrDropFraudSpikeDepositDropWithSRoute;
